export class Activity111{
    no:string;
    date:Date;
    address: string;
    gs:string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity112{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity121{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity122{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    newcase: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity123{
    no:string;
    date:Date;
    address: string;
    gsdevision:string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity124{
    no:string;
    date:Date;
    address: string;
    gsdevision:string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity125{
    no:string;
    name:string;
    district: string;
    status:any;
    homegarden: any;
    budget: any;
    spent:any;
    balance:any;
}
export class Activity126{
    no:string;
    name:string;
    district: string;
    nooftimes: any;
    noofpatients: any;
    impact: any;
    budget:any;
    spent:any;
    balance:any;
}

export class Activity131{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}

export class Activity132{
    no:string;
    date:Date;
    place: string;
    programme:string;
    noofpatients: any;
    budget:any;
    spent:any;
    balance:any;
}

export class Activity133{
    no:string;
    date:Date;
    address: string;
    gsdevision:string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity134{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity135{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity138{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity139{
    no:string;
    date:Date;
    place: string;
    programme:string;
    noofpatients: any;
    budget:any;
    spent:any;
    balance:any;
}

export class Activity211{
    no:string;
    place: string;
    programme:string;
    noofgroups:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity212{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity213{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity222{
    no:string;
    date:Date;
    programme: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity223{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity225{
    no:string;
    date:Date;
    address: string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity3131{
    no:string;
    date:Date;
    address: string;
    homegarden:string;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity311{
    no:string;
    date:Date;
    address: string;
    gsdevision:string;
    methodology:any;
    participants: any;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity323{
    no:string;
    name:string;
    address: string;
    benifits:string;
    budget:any;
    spent:any;
    balance:any;
}
export class Activity324{
    no:string;
    district: string;
    programme:string;
    participant: any;
    budget:any;
    spent:any;
    balance:any;
}

export class Kpl{
    no:string;
    date: Date;
    name:string;
    village: any;
    gn:any;
    ds:any;
    district:any;
    total:any;
}
export class Poverty{
    no:string;
    name:string;
    age: any;
    sex:any;
    village: any;
    gn:any;
    ds:any;
    district:any;
    y1:any;
    y2:any;
    y3:any;
    y4:any;
    year1:[];
    year2:any;
    year3:any;
}

export class Income{
    no:string;
    name:string;
    age: any;
    sex:any;
    village: any;
    gn:any;
    ds:any;
    district:any;
    y1:any;
    y2:any;
    y3:any;
    y4:any;
    basicincome:any;
    by2:any;
    by3:any;
    by4:any;
}
export class Scale{
    no:string;
    names:string;
    sex:any;
    village: any;
    gn:any;
    ds:any;
    district:any;
    y1:any;
    y2:any;
    y3:any;
}

export class Score{
    no:string;
    name:string;
    sex:any;
    district: any;
    diagnoseddate:Date;
    eye:any;
    hand:any;
    leg:any;
    y1:any;
    py1:any;
    y2:any;
    py2:any;
    y3:any;
    py3:any;
}

export class Scg{
    no:string;
    gno:string;
    name:string;
    sex:any;
    district: any;
    age: any;
    mb:any;
    card:any;
    ehf:any;
    ehfscore:any;
    ehfscore2:any;
}

